import { Target } from 'lucide-react';

interface DailyFocusCardProps {
  focusItems: string[];
}

const DailyFocusCard = ({ focusItems }: DailyFocusCardProps) => {
  return (
    <div className="bg-card rounded-2xl p-4 shadow-card">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-7 h-7 rounded-lg bg-wellness-peach-light flex items-center justify-center">
          <Target className="h-3.5 w-3.5 text-wellness-peach" />
        </div>
        <h2 className="text-sm font-semibold">Tu enfoque de hoy</h2>
      </div>
      <div className="space-y-2">
        {focusItems.slice(0, 3).map((item, idx) => (
          <div key={idx} className="flex items-start gap-2.5">
            <div className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0" />
            <p className="text-sm text-muted-foreground leading-relaxed">{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DailyFocusCard;
